import { Auth } from "aws-amplify";

const changePassword = async (user: any, oldPassword: string, newPassword: string) => {
  await Auth.changePassword(user, oldPassword, newPassword);
};

export default changePassword;
